module.exports = __webpack_public_path__ + "img/1_uk.a133ee56.svg";